import classNames from 'classnames';

import styles from '../../../styles/icons/base.module.scss';

interface LuggageProps {
    color?: string;
    className?: string;
}

function Luggage({ color = '#000', className = null }: LuggageProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            className={classNames([styles.container, { [className]: className !== null }])}
        >
            <path
                fill={color}
                d="M21 7V6H17V3H7V6H3V7H2V20H3V21H21V20H22V7H21ZM20 18H19V19H17V8H19V9H20V18ZM4 18V9H5V8H7V19H5V18H4ZM9 5H15V6H9V5ZM9 8H15V19H9V8Z"
            />
        </svg>
    );
}

export default Luggage;
